var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEuro = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31598_98028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 12.6711 18.9598 15.1825 17.0711 17.0711C15.1825 18.9598 12.6711 20 10 20C7.32895 20 4.8175 18.9598 2.92892 17.0711C1.04019 15.1825 0 12.6711 0 10C0 7.32895 1.04019 4.8175 2.92892 2.92892C4.8175 1.04019 7.32895 0 10 0C12.6711 0 15.1825 1.04019 17.0711 2.92892C18.9598 4.8175 20 7.32895 20 10Z",
    fill: "#6EA1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 12.6711 18.9598 15.1825 17.0711 17.0711C15.1825 18.9598 12.6711 20 10 20V0C12.6711 0 15.1825 1.04019 17.0711 2.92892C18.9598 4.8175 20 7.32895 20 10Z",
    fill: "#3B75D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8906 10C17.8906 14.3507 14.3507 17.8906 10 17.8906C5.64926 17.8906 2.10938 14.3507 2.10938 10C2.10938 5.64926 5.64926 2.10938 10 2.10938C14.3507 2.10938 17.8906 5.64926 17.8906 10Z",
    fill: "#285FB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45543 8.45634C8.52765 8.36028 8.60748 8.26813 8.6949 8.1807C9.69993 7.17567 11.3294 7.17567 12.3344 8.1807L13.4263 7.08885C11.8182 5.4808 9.21109 5.4808 7.60305 7.08885C7.19959 7.4923 6.89736 7.95865 6.69636 8.45634H5.88232V9.48575H6.42912C6.38632 9.82745 6.38632 10.1735 6.42912 10.5152H5.88232V11.5446H6.69636C6.89736 12.0422 7.19959 12.5086 7.60305 12.9121C9.21109 14.5201 11.8182 14.5201 13.4263 12.9121L12.3344 11.8202C11.3294 12.8253 9.69993 12.8253 8.6949 11.8202C8.60748 11.7328 8.52765 11.6406 8.45543 11.5446H10.5147V10.5152H7.99284C7.9239 10.1758 7.9239 9.82515 7.99284 9.48575H10.5147V8.45634H8.45543Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31598_98028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEuro);
export default ForwardRef;